import { render, staticRenderFns } from "./InputFieldPercentage.vue?vue&type=template&id=89493596&scoped=true"
import script from "./InputFieldPercentage.vue?vue&type=script&lang=js"
export * from "./InputFieldPercentage.vue?vue&type=script&lang=js"
import style0 from "./InputFieldPercentage.vue?vue&type=style&index=0&id=89493596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89493596",
  null
  
)

export default component.exports